var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../../config/config';
import { mapProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchShopify } from './api';
export class ShopifySearchProvider {
    constructor() {
        this.products = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
        this.currentFilters = {};
        this.currentPage = 1;
        this.currentPageSize = AppConfig.page.defaultSize;
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            var _a;
            const { page = 1, pageSize = AppConfig.page.defaultSize, sort = 'relevance', filters } = options;
            this.currentPage = page;
            this.currentPageSize = pageSize;
            if (filters) {
                this.currentFilters = filters;
            }
            try {
                // Check if query looks like a collection handle
                const isCollection = query.startsWith('collection:');
                const collection = isCollection ? query.replace('collection:', '') : undefined;
                const searchQuery = isCollection ? '' : query;
                const response = yield fetchShopify({
                    query: searchQuery,
                    page,
                    pageSize,
                    sort,
                    filters: this.currentFilters,
                    collection
                });
                // Extract products from response
                const productsData = response.data.products || ((_a = response.data.collection) === null || _a === void 0 ? void 0 : _a.products);
                if (!productsData) {
                    this.products = [];
                    this.filters = [];
                    this.meta = {
                        totalResults: 0,
                        totalPages: 0,
                        currentPage: page,
                        pageSize
                    };
                    return;
                }
                const shopifyProducts = productsData.edges.map(edge => edge.node);
                this.products = mapProducts(shopifyProducts);
                this.filters = mapFilters(shopifyProducts, this.currentFilters);
                this.meta = mapMeta(response, page, pageSize);
                this.sortOptions = mapSorts();
            }
            catch (error) {
                console.error('Error fetching from Shopify:', error);
                // Set empty results on error
                this.products = [];
                this.filters = [];
                this.meta = {
                    totalResults: 0,
                    totalPages: 0,
                    currentPage: page,
                    pageSize
                };
                this.sortOptions = mapSorts();
                throw error;
            }
        });
    }
    getProducts() {
        return this.products;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            return {
                totalResults: 0,
                totalPages: 0,
                currentPage: this.currentPage,
                pageSize: this.currentPageSize
            };
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
}
